<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="auto" >
        <Datepicker :placeholder="'Select date'" v-model="selectedDate" @selected="dateSelected"/>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col>
        <b-spinner v-if="loading" variant="success" label="Spinning"></b-spinner>
        <span v-if="!loading && races && races.length === 0">No races found for date</span>
        <span v-if="!loading && error">{{errorText}}</span>
      </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
      <b-col md="5" cols='12'>
        <PredictionTablev2 v-if="!loading" :races="races" v-on:raceSelected="raceSelected($event)" v-on:racesError="raceLoadingError"/>
      </b-col>
      <b-col md="4">
        <HorseScoresTable v-if="selectedRace" :horses="selectedRace.horses" v-on:horseSelected="horseSelected($event)"></HorseScoresTable>
      </b-col>
      <b-col md="3">
        <HorseSkillHistoryTable v-if="selectedHorse" :horseName="selectedHorse.name" :raceType="selectedRace.raceType"></HorseSkillHistoryTable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment'
import PredictionTablev2 from './PredictionTablev2';
import PredictionSummaryTable from './PredictionSummaryTable';
import HorseScoresTable from './HorseScoresTable'
import HorseSkillHistoryTable from './HorseSkillHistoryTable'
import {getRacesv2} from '../clients/RacesClient'

export default {
  name: 'PredictionList',
  components: {
    Datepicker,PredictionTablev2, PredictionSummaryTable,HorseScoresTable, HorseSkillHistoryTable
  },
  props: {
  },
  data () {
    return {
      title: 'PredictionList',
      dateNumber: undefined,
      selectedDate: undefined,
      loading: true,
      races: undefined,
      reloadCount: 0,
      errorText:undefined,
      error: false,
      selectedRace: undefined,
      selectedHorse: undefined
    }
  },
  methods: {
    dateSelected: function(date) {
      this.dateNumber = moment(date).format('YYYYMMDD') * 1
      if (this.$route.query.date !== this.dateNumber + "") this.$router.push({query:{date:this.dateNumber + ""}})
      this.loadRaces()
    },
    raceSelected: function(race) {
      this.$emit("raceSelected", race)
      this.selectedRace = race
    },
    horseSelected: function(horse) {
      this.selectedHorse = horse
      console.log(horse)
    },
    loadRaces: async function() {
      this.loading = true
      this.races = await getRacesv2(this.dateNumber)
      this.loading = false
    },
    racesLoaded: function (races) {
      this.races = races
      this.reloadCount++
      if (this.races && this.races.filter(race => race.actualWinner).length > 0) {
        this.racesHaveWinners = true
      }else {
        this.racesHaveWinners = false
      }
    },
    raceLoadingError: function(err) {
      this.error = true
      console.log(err)
      this.errorText = "Issue loading races: "  + (err.response? err.response.status : err.toString())
    }
  },
  mounted () {
    this.races = undefined
    this.loadRaces()
    if (!this.$route.query.date) {
      this.$router.push({query:{date:moment().format('YYYYMMDD')}})
    }
    var thisDate = new Date(this.$route.query.date.substr(0,4),1 * this.$route.query.date.substr(4,2) - 1,this.$route.query.date.substr(6,2))
    this.selectedDate = thisDate
    this.dateSelected(thisDate)
  }
}

</script>
<style>
.vdp-datepicker {
  color: black;
  cursor: pointer;
  text-align: center;
}


.vdp-datepicker div input {
  color: white;
  cursor: pointer;
  padding: 10px;
  text-align: center;
  background-color: #393943;
  border: none
}

.row {
  margin-bottom: 10px
}
</style>
